<template>
  <div class="modal" v-if="isVisible">
    <div class="modal-content" @wheel="handleWheel" :style="divScale" >
      <span class="close" @click="closeModal">&times;</span>
      <img  class="img-box"
            :style="imgScale"
            :src="imageUrl" alt="Modal Image"
            draggable="true"
            @dragstart="dragstart($event)"
            @dragend="dragend($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "modalImage",
  props: ['imageUrl'],
  data() {
    return {
      isVisible: false,
      scale:1,
      startclientX: 0, // 元素拖拽前距离浏览器的X轴位置
      startclientY: 0, //元素拖拽前距离浏览器的Y轴位置
      elLeft: 0, // 元素的左偏移量
      elTop: 0, // 元素的右偏移量
    };
  },
  computed:{
    divScale: function (){
      return "transform: scale("+ this.scale +","+ this.scale + ");";
    },
    imgScale: function (){
      return "transform: scale("+ this.scale +","+ this.scale + ");" +
             "left:" + this.elLeft + "px;top:"+ this.elTop + "px;";
    }
  },
  methods: {
    handleWheel(event) {
      if(event.deltaY > 0){
        this.scale = this.scale + 0.05;
      }else{
        this.scale = this.scale - 0.05;
      }
      event.preventDefault();
    },
    // 拖拽开始事件
    dragstart(e) {
      console.log(e);
      this.startclientX = e.clientX; // 记录拖拽元素初始位置
      this.startclientY = e.clientY;
    },

    // 拖拽完成事件
    dragend(e) {
      console.log(e);
      let x = e.clientX - this.startclientX; // 计算偏移量
      let y = e.clientY - this.startclientY;
      this.elLeft += x; // 实现拖拽元素随偏移量移动
      this.elTop += y;
    },

    openModal() {
      this.isVisible = true;
      this.scale = 1;
    },
    closeModal() {
      this.isVisible = false;
    },
  },
}
</script>

<style scoped>
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */

  background-color: rgb(200,200,200); /* Fallback color */
  background-color: rgba(250,250,250,0.5); /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  margin: 5% auto; /* 15% from the top and centered */
  padding: 20px;
  padding-top: 30px;
  border: 1px solid #888;
  width: 60%; /* Could be more or less, depending on screen size */
  height: 80%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.close {
  color: #aaa;
  /*float: right;*/
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.img-box{
  margin: auto;
  position: absolute;
}

</style>
